import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';

class DepositGraph extends Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [],
      options: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        title: {
          text: 'Total Deposit Amount by Month',
          align: 'left',
        },
        grid: {
          row: {
            colors: ['#009EDF', 'transparent'],
            opacity: 0.2,
          },
        },
        xaxis: {
          categories: [],
        },
      },
    };
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/monthly-deposit-data`);
    
        if (response.data.status === 200) {
          const rawData = response.data.data;
    
          // Initialize an object to store the processed data
          const processedData = {};
    
          // Loop through the raw data and process it
          rawData.forEach((entry) => {
            const date = entry.date;
            const values = { "USDT": "0", "ZAR": "0", "BTC": "0" }; // Default values for "USDT," "ZAR," and "BTC"
    
            // Copy the actual values if present
            if (entry["1"] !== undefined) values["USDT"] = entry["1"];
            if (entry["2"] !== undefined) values["ZAR"] = entry["2"];
            if (entry["3"] !== undefined) values["BTC"] = entry["3"];
    
            // Add the processed entry to the result
            processedData[date] = values;
          });
    
          // Create series for the chart
          const series = ["USDT", "ZAR", "BTC"].map((currency) => ({
            name: currency,
            data: Object.values(processedData).map((entry) => entry[currency]),
          }));
    
          // Create options for the chart
          const options = {
            ...this.state.options,
            xaxis: {
              ...this.state.options.xaxis,
              categories: Object.keys(processedData),
            },
            tooltip: {
              y: {
                formatter: function (value) {
                  return value.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  });
                },
              },
            },
          };
    
          this.setState({ series, options });
        } else {
          console.error('Failed to fetch monthly deposit data:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching monthly deposit data:', error);
      }
  }

  render() {
    return (
      <div id="chart">
        <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={350} />
      </div>
    );
  }
}

export default DepositGraph;
